import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const KajIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99563)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.399 21.839L5.55 17.507L8.352 14H6.352L4.342 16.596L3.626 17.577V14H2V21.892H3.626V19.637L4.472 18.727L6.499 21.892H8.407H8.379L8.399 21.839ZM8 12H24V24H0V12H3V8H8V12ZM8.399 21.839L8.434 21.892H8.407H10.108L10.65 20.266H13.501L14.049 21.892H15.778L12.824 14H11.317L8.399 21.839ZM11.089 18.949L12.07 15.995L13.062 18.949H11.09H11.089ZM19.696 14V19.463C19.696 19.857 19.604 20.161 19.42 20.374C19.236 20.587 18.988 20.694 18.678 20.694C18.327 20.694 18.07 20.602 17.908 20.417C17.745 20.233 17.664 19.947 17.664 19.561H16.027C16.027 20.338 16.26 20.939 16.727 21.363C17.192 21.788 17.843 22 18.677 22C19.187 22 19.644 21.895 20.049 21.686C20.453 21.476 20.767 21.179 20.989 20.794C21.211 20.409 21.322 19.966 21.322 19.464V14H19.696ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99563'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

KajIcon.displayName = 'KajIcon'
